import React from 'react'
import { AboutInnerBanner } from '../../Components/Common/InnerBanner/AboutInnerBanner'
import AboutContent from '../../Components/Common/AboutContent/AboutContent'
import AboutInnBanContent from '../../Components/Common/InnerBanner/AboutInnBanContent'
import AboutInfo from '../../Components/Common/AboutContent/AboutInfo'
import Transition from '../../Components/Transition'
import { Helmet } from 'react-helmet'

const AdvancedTechnology = () => {
    const {image, heading, pageName} = AboutInnBanContent.advancedTechnology;
    const {bg, doctor, title, data} = AboutInfo.advancedTechnology;

  return (
    <>
    <Helmet>
      <title>Advanced IVF Technology at ACME FERTILITY, Chembur</title>
      <meta name='description' content='Best advanced IVF technology at ACME FERTILITY, Chembur, ensuring high success rates with innovative procedures and care' />
      <meta name='keywords' content='in vitro fertilization ivf , air purification ivf in vitro fertilization , in vitro fertilization near me , in vitro fertilization process best ivf clinic in the world, icsi procedure , icsi fertility , ivf full form in medical' />
      <link rel="canonical" href="https://www.acmefertility.com/AdvancedTechnology" />
      <meta name="robots" content="Index, follow " />
    </Helmet>
    <AboutInnerBanner image={image} heading={heading} pageName={pageName} />
    <AboutContent bg={bg} doctor={doctor} title={title} data={data} />
    </>
  )
}

export default Transition(AdvancedTechnology) 